import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'; // @ts-expect-error untyped module

import { getIsUngatedForModulesStorefront } from '../selectors/auth';
import TemplatesHomeContainer from './containers/TemplatesHomeContainer';
export default function TemplatesRoutes() {
  const {
    path
  } = useRouteMatch();
  const isUngatedForModulesStorefront = useSelector(getIsUngatedForModulesStorefront);

  if (!isUngatedForModulesStorefront) {
    return /*#__PURE__*/_jsx(Switch, {
      children: /*#__PURE__*/_jsx(Redirect, {
        to: "/website"
      })
    });
  }

  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: path,
      exact: true,
      children: /*#__PURE__*/_jsx(TemplatesHomeContainer, {})
    }), /*#__PURE__*/_jsx(Redirect, {
      to: path
    })]
  });
}